import React from "react";
import './skills.css';
import AppDesign from '../../assets/app-design.png';
import UIDesign from '../../assets/ui-design.png';
import WebDesign from '../../assets/website-design.png';

const Skills = () => {
    return (
        <section id="skills">
            <span className="skillTitle">What am I doing?</span>
            <span className="skillDesc">The duties of a farm manager usually cover several important aspects in managing agricultural operations and crop production. Here are three main duties of a farm manager:</span>
            <div className="skillBars">
                <div className="skillBar">
                    <img src={UIDesign} alt="UIDesign" className="skillBarImg"/>
                    <div className="skillBarText">
                        <h2>Planning and Management of Farm Operations</h2>
                        <p>The primary duty of a Farm Manager is to develop daily, seasonal, and annual work plans (such as planting/livestock upkeep, and harvesting/production), allocate resources (labour, water, feed, medication), and ensure all operational activities run efficiently according to the Standard Operational Procedures (SOPs) to achieve maximum production targets and profitability.</p>
                    </div>
                </div>
                <div className="skillBar">
                    <img src={WebDesign} alt="WebDesign" className="skillBarImg"/>
                    <div className="skillBarText">
                        <h2>Monitoring Health and Product Quality</h2>
                        <p>The Farm Manager is responsible for regularly monitoring the health of crops or livestock, implementing strict biosecurity measures, controlling pests/diseases, and ensuring the quality of harvests or livestock products meets established standards. This duty includes coordinating with specialists (e.g., Agronomists or Veterinarians).</p>
                    </div>
                </div>
                <div className="skillBar">
                    <img src={AppDesign} alt="AppDesign" className="skillBarImg"/>
                    <div className="skillBarText">
                        <h2>Financial and Resource Administration Management</h2>
                        <p>Executes administrative functions including preparing and managing the budget, recording all transactions and operational costs, overseeing inventory (raw materials, supplies, and equipment), and managing the performance and training of farm staff to ensure the team works effectively and safely. </p>
                    </div>
                </div>
            </div>
        </section>
    )
}


export default Skills;